// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B9Uf","select":"styles_select__3tCrR"};